import React from "react";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height: number;
  width: number;
  color: string;
}

const IconXCircle = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 20 20"
      >
        <g
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          clipPath="url(#clip0_1780_96709)"
        >
          <path d="M9.997 18.334a8.333 8.333 0 100-16.667 8.333 8.333 0 000 16.667zM12.5 7.5l-5 5M7.5 7.5l5 5"></path>
        </g>
        <defs>
          <clipPath id="clip0_1780_96709">
            <path fill="#fff" d="M0 0H20V20H0z"></path>
          </clipPath>
        </defs>
      </svg>
    </SvgWrapper>
  );
};

export default IconXCircle;
